import { type IDataField } from '@telespot/domain';
import { type AssetRepository } from '../../ports';

export interface GetAssetMetadataPayload {
  assetId: string;
}

/**
 * Returns the persisted metadata (`data`) of an asset. Used by the discard flow to restore
 * the last saved values.
 */
export class GetAssetMetadataUseCase {
  constructor(private readonly assets: AssetRepository) {}

  public async execute(input: Readonly<GetAssetMetadataPayload>): Promise<IDataField> {
    const asset = await this.assets.getById(input.assetId);

    return asset.data;
  }
}
